import React, { PureComponent } from 'react';
import moment from 'moment';

import { List as ListIcon } from '@mui/icons-material';

import Tile from '../../../common/components/Tile/Tile';
import DateTimeFilter from '../../../common/components/Filters/DateTimeFilter';
import TableEnhancedContainer from '../../../common/components/TableEnhanced/TableEnhancedContainer';
import Loading from '../../../common/components/Loading/Loading';
import '../UserAuditLogs.css';

const Table = (props) => (
  <Tile
    title="User audit logs"
    TitleIcon={ListIcon}
    className={props.className}
    helpTag="user_audit_logs-table"
  >
    <TableEnhancedContainer
      data={props.tableData}
      columns={props.columnsConfig}
      className="UserAuditLogsTable"
      enableHideColumns={true}
      enableActionButtons={true}
    />
  </Tile>
);

class UserAuditLogsView extends PureComponent {
  render() {
    return (
      <div className="user_audit_logs">
        <div className="u-mb-full">
          <DateTimeFilter
            dateTimeFromFilter={this.props.dateFrom}
            dateTimeToFilter={this.props.dateTo}
            onChangeDateTime={this.props.onChangeDateTime}
            onApplyFilters={this.props.onApplyFilters}
            isFetching={this.props.isFetching}
            metadata={this.props.metadata}
            dateTimeErrorMessage={this.props.dateTimeErrorMessage}
          />
        </div>
        <Loading condition={this.props.isFetching}>
          <Table tableData={this.props.tableData} columnsConfig={this.props.columnsConfig} />
        </Loading>
      </div>
    );
  }
}

export default UserAuditLogsView;
